import ContactTypeDot from "../../../../ui library/components/indicators/ContactTypeDot";
import HNSColors from "../../../../ui library/HNSColors";

export default function ContactTypeBadges({ badges = [] }) {
  if (!badges.length) {
    return null;
  }

  return (
    // Sized to its content so the header row wraps the group as a whole rather than
    // squeezing it into whatever space is left: with a few badges it sits inline beside the
    // law firm, with many it drops to its own line. Labels never break mid-word, and the
    // group wraps internally only once it has the full row to itself.
    <div className="flex min-w-fit max-w-full flex-wrap items-center justify-center gap-x-3 gap-y-1">
      {badges.map(({ key, text, color }) => (
        <div key={key} className="flex items-center gap-1.5">
          <ContactTypeDot color={color || HNSColors.neutrals[500]} />
          <span
            className="whitespace-nowrap text-[14px]"
            style={{ color: HNSColors.neutrals[300] }}
          >
            {text}
          </span>
        </div>
      ))}
    </div>
  );
}
